// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".popover-container[data-v-59abefec]{position:relative;display:inline-block}.popover-trigger[data-v-59abefec]{all:unset;cursor:pointer}.popover-content[data-v-59abefec]{position:absolute;bottom:100%;right:0;margin-bottom:8px;z-index:50;box-shadow:0 2px 10px rgba(0,0,0,.1);border-radius:4px}", ""]);
// Exports
module.exports = exports;
